module.exports = __webpack_public_path__ + "static/media/accomodations.1b54db2d.avif";